import { IStockInitObservationStatus } from './stock-take-date-sync.interface';

/**
 * Request payload for the `beginStockInitialization` Firebase callable.
 */
export interface IBeginStockInitializationRequest {
  storeId: string;
  /**
   * When true, restart STOCK_INIT even if a prior run already succeeded (resync).
   * Omit/false for the first sync. Backend writes the later of IQ and existing Gallix dates.
   */
  force?: boolean;
}

/**
 * Response from the `beginStockInitialization` Firebase callable.
 */
export interface IStockInitTriggerResponse {
  message: string;
  observationPath: string;
  status: IStockInitObservationStatus;
}
